/** @module app.test */

export const testFixtureDefinitionSymbol = Symbol('testFixture');
export const testDefinitionSymbol = Symbol('test');
